import {api, paramEncoder} from "./repository";
const resource = "/invites";

export default {
    getAll(params) {
        return api.get(`${resource}${paramEncoder(params)}`);
    },
    store(payload) {
        return api.post(resource, payload);
    },
    getById(id, params) {
        return api.get(`${resource}/${id}${paramEncoder(params)}`);
    },
    getByPublicUuid(uuid, params){
        return api.get(`invitation/${uuid}${paramEncoder(params)}`);
    },
    confirm(uuid, payload){
        return api.post(`invitation/${uuid}/confirm`, payload);
    },
    update(payload) {
        let id = payload.id;
        return api.put(`${resource}/${id}`, payload);
    },
    destroy(id) {
        return api.delete(`${resource}/${id}`);
    },
    sendEmails(ids){
        return api.post(`${resource}/send-email`, {ids})
    }
}